export default "__VITE_ASSET__BxNDQE0m__"